package team.platforma.multiplatform_material_extension.model

data class RequiredField(
    val boolean: Boolean,
    val message: String
)
